module.exports = __webpack_public_path__ + "ec8e2977c69df9697192f9ab767511fd.glb";